
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Navigation',
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  }
})
